module.exports = __webpack_public_path__ + "static/media/cq_richieste_in_corso.ca0d1d77.svg";